import React from 'react';
import Styled from 'styled';
import { observer } from 'mobx-react';
import RouteLinkView from 'lib/ui/route-link-view';
import defaultStyles from './pager-element-view.scss';

export default Styled(defaultStyles)(
    observer(function PagerElementView(props) {
        const { selected, styles, href, onClick, linkify } = props;
        const classNames = [styles.pagerElement];

        if (href) {
            classNames.push(styles.hasHref);
        }

        if (selected) {
            classNames.push(styles.selected);
        }

        const children = <span className={styles.children}>{props.children}</span>;

        let type;
        if (onClick) {
            if (href && linkify) {
                type = RouteLinkView;
            } else {
                type = 'button';
            }
        } else {
            type = 'span';
        }
        return React.createElement(
            type,
            {
                className: classNames.join(' '),
                onClick,
                href,
                'aria-label': type !== 'span' ? `pager-${type === 'button' ? 'button' : 'link'}` : undefined,
            },
            children
        );
    })
);
